import { Component } from '@angular/core';
import { PageContainerComponent } from '../../layout/page-container/page-container.component';
import { LAYOUT_TYPE } from '../../model/common.model';
import { TabConfig } from '../../model/form.model';
import { getEliteCertificationTabConfig } from '../../model/elite-certification.model';
import { EliteCertificationReportComponent } from '../elite-certification-report/elite-certification-report.component';

@Component({
  selector: 'app-elite-certification',
  standalone: true,
  imports: [PageContainerComponent],
  templateUrl: './elite-certification.component.html',
  styleUrls: ['./elite-certification.component.scss']
})
export class EliteCertificationComponent {
  readonly LayoutType: typeof LAYOUT_TYPE = LAYOUT_TYPE;
  title = 'Elite Certification';
  public tabConfig: Array<TabConfig> = getEliteCertificationTabConfig(
    EliteCertificationReportComponent,
  );
}
